import React, { useCallback, useEffect, useState, forwardRef, LegacyRef } from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { IconChevronDown, IconChevronUp } from '@wds/icons';

import useStyles from './useStyles';

const Accordion = forwardRef(function Accordion(
  { title, isExpanded, children }: { title: string; isExpanded: boolean; children: React.ReactNode },
  ref: LegacyRef<HTMLDivElement> | undefined
): JSX.Element {
  const { AccordionContainer, Collapsed, Trigger } = useStyles();
  const [expanded, setExpanded] = useState(isExpanded);

  const icon = expanded ? (
    <IconChevronUp title="Expanded" color="darkMuted" />
  ) : (
    <IconChevronDown title="Collapsed" color="darkMuted" />
  );

  const handleClick = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  useEffect(() => {
    setExpanded(isExpanded);
  }, [isExpanded]);

  return (
    <div className={AccordionContainer} ref={ref}>
      <Box className={Trigger} onClick={handleClick} role="button">
        <Typography weight="medium">{title}</Typography>
        <Box>{icon}</Box>
      </Box>
      <Box className={!expanded ? Collapsed : ''}>{children}</Box>
    </div>
  );
});

export default Accordion;
